module.exports = __webpack_public_path__ + "assets/img/gloves.e4a1b324.png";